import { defineMessages } from 'react-intl';

const translations = {
  notifications: {
    none: {
      id: 'app.notifications.none',
      defaultMessage: 'No notifications',
      description: 'message to show when notifications are empty',
    },
    tabs: {
      spooler: {
        id: 'app.title',
        defaultMessage: 'Spooler',
        description: 'label of the spooler notifications tab',
      },
      all: {
        id: 'app.notifications.all',
        defaultMessage: 'All notifications',
        description: 'label of the global notifications tab',
      },
    },
  },
  dock: {
    dashboard: {
      id: 'app.dock.dashboard',
      defaultMessage: 'Overview',
      description: 'label of the dock item dashboard',
    },
    spooler: {
      id: 'app.dock.spooler',
      defaultMessage: 'Spooler',
      description: 'label of the dock item spooler',
    },
    picker: {
      id: 'app.dock.picker',
      defaultMessage: 'Picker',
      description: 'label of the dock item picker',
    },
    notifications: {
      id: 'app.dock.notifications',
      defaultMessage: 'Notifications',
      description: 'label of the dock item notifications',
    },
    user: {
      id: 'app.dock.user',
      defaultMessage: 'User',
      description: 'label of the dock item user',
    },
    userMenu: {
      signOut: {
        id: 'app.dock.userMenu.signOut',
        defaultMessage: 'Sign out',
        description: 'label of the sign out link in the user menu',
      },
    },
  },
  drawer: {
    title: {
      id: 'app.company',
      defaultMessage: 'Afosto',
      description: 'drawer header title',
    },
    appTitle: {
      id: 'app.title',
      defaultMessage: 'Afosto',
      description: 'drawer app title',
    },
    primaryAction: {
      label: {
        id: 'actions.add',
        defaultMessage: 'Add',
        description: 'Label of the button for the primary action',
      },
      options: {
        printer: {
          id: 'entities.printers',
          defaultMessage: 'Printer',
          description: 'Label primary action option printer',
        },
        hub: {
          id: 'entities.hubs',
          defaultMessage: 'Hub',
          description: 'Label of the primary action option hub',
        },
      },
    },
  },
  appBar: {
    search: {
      placeholder: {
        id: 'app.appBar.search.placeholder',
        defaultMessage: 'Search',
        description: 'placeholder of the search input',
      },
      label: {
        id: 'app.appBar.search.label',
        defaultMessage: 'Search',
        description: 'label of the search input',
      },
    },
  },
};

export default defineMessages(translations);
